<template>
  <v-text-field ref="textField"
                v-model="search"
                :label="typeof label === 'string' ? label : 'Search'"
                clearable autofocus
                outlined
                prepend-inner-icon="mdi-magnify"
                dense
                class="text-caption"
                @input="keyDown">
    <template v-slot:append v-if="typeof label !== 'string'">
      <v-select :items="label" v-model="name"
                 dense hide-details flat outlined solo class="text-caption mt-n2"
                 background-color="xgrey xlighten-5 pl-2 pr-0"
                 style="position:relative; left:12px; border-top-left-radius:0; border-bottom-left-radius:0"
                 @change="$emit('update:searchField', name)"/>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'FilterSearch',
  props: {
    value: {type:String,required:false},
    label: {type:[String,Array],required:false,default:'Search'},
    searchField: {type:String,required:false},
    searchDisplay: {type:String, required:false}
  },
  data() {
    return {
      search: this.value,
      timerId: null,
      name: this.searchField
    }
  },
  created() {
    this.setDisplay();
  },
  watch: {
    value(newValue) {
      this.search = newValue;
      this.setDisplay();
    },
    searchField(newValue) {
      this.name = newValue;
      this.setDisplay();
    }
  },
  methods: {
    keyDown() {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.valueChanged()
      }, 500);
    },
    setDisplay() {
      if (typeof this.label !== 'string' && this.label)
        this.$emit('update:searchDisplay', `${this.label.find(l => l.value === this.name).text}: ${this.search}`);
    },
    valueChanged() {
      this.$emit('input', this.search);
      this.$emit('change', this.search);
      this.setDisplay();
    },
  }
}

</script>
